// USE onAccept TO HANDLE CHANGES WITHIN MASKED FIELDS (docs: https://www.npmjs.com/package/react-imask)
import React, { forwardRef } from 'react';
import { IMaskMixin } from 'react-imask';
import StyledInput, { useStyles, styles } from './styles';

const MaskedInput = IMaskMixin(({ inputRef, ...props }) => {
  const classes = useStyles(props);
  const { mask, unmask, ...rest } = props;

  return (
    <StyledInput
      {...rest}
      inputRef={inputRef}
      className={classes.styles}
      FormHelperTextProps={{ style: styles.helperText }}
    />
  );
});

const Input = forwardRef((props, ref) => (
  <MaskedInput
    {...props}
    variant="standard"
    inputRef={ref}
    inputProps={{
      ...props.inputProps,
      autoComplete: props.autoComplete || 'off',
    }}
  />
));

export default Input;
